/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiCaseAttachmentType {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION',
    SCREENING_ALERT = 'SCREENING_ALERT',
    MONITORING_ALERT = 'MONITORING_ALERT',
    BRIDGE_ALERT = 'BRIDGE_ALERT',
    MANUAL_ALERT = 'MANUAL_ALERT'
}


export function instanceOfInternalApiCaseAttachmentType(value: any): boolean {
    for (const key in InternalApiCaseAttachmentType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiCaseAttachmentType, key)) {
            if (InternalApiCaseAttachmentType[key as keyof typeof InternalApiCaseAttachmentType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiCaseAttachmentTypeFromJSON(json: any): InternalApiCaseAttachmentType {
    return InternalApiCaseAttachmentTypeFromJSONTyped(json, false);
}

export function InternalApiCaseAttachmentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseAttachmentType {
    return json as InternalApiCaseAttachmentType;
}

export function InternalApiCaseAttachmentTypeToJSON(value?: InternalApiCaseAttachmentType | null): any {
    return value as any;
}

export function InternalApiCaseAttachmentTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiCaseAttachmentType {
    return value as InternalApiCaseAttachmentType;
}

